import api from '../api/axios';

export const testPackageService = {
  // Get test package details by ID
  getTestPackageById: async (packageId) => {
    try {
      const response = await api.get(`/medical-test-packages/${packageId}/`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch test package details' };
    }
  },

  // Get all test packages (if needed)
  getAllTestPackages: async () => {
    try {
      const response = await api.get('/medical-test-packages/');
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch test packages' };
    }
  },

  // Get related test packages
  getRelatedPackages: async (packageId) => {
    try {
      const response = await api.get(`/suggestions/related-test-packages/${packageId}/`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch related packages' };
    }
  }
};

export default testPackageService;
